import styled from 'styled-components'
import { Theme } from 'features/ui/types'
import { AutomationId, AUTO_ATTR_KEY } from 'utils/automationUtil'

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const StyledAvatarLink = styled.a`
  display: contents;
  text-decoration: none;
`

export const StyledAuthorLink = styled.a.attrs({ [AUTO_ATTR_KEY]: AutomationId.author.name })`
  display: flex;
  flex-direction: row;
  color: ${({ mode }: { mode: Theme }) => (mode === 'light' ? '#13797D' : '#72C3C6')};
  text-decoration: none;
  font-size: 14px;
  line-height: 22px;
  gap: 4px;
  align-items: flex-start;
`

export const StyledAuthorName = styled.div.attrs({ [AUTO_ATTR_KEY]: AutomationId.author.name })`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 4px;
  color: ${({ mode }: { mode: Theme }) => (mode === 'light' ? '#1B1F22' : '#FFFFFF')};
  font-size: 14px;
  line-height: 22px;
`

export const StyledAuthorNameContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  overflow: hidden;
  gap: 4px;
`

export const StyledContent = styled.div`
  /* line-clamp */
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
`

export const StyledIconContainer = styled.div`
  height: 22px;
  display: flex;
  align-items: center;
`

export const StyledAuthorHandleContainer = styled.div`
  width: 100%;
  height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const StyledAuthorHandle = styled.div.attrs({
  [AUTO_ATTR_KEY]: AutomationId.author.handle
})`
  color: ${({ mode }: { mode: Theme }) => (mode === 'light' ? '#49535A' : '#E3E6E8')};
  font-size: 12px;
  line-height: 18px;
  text-overflow: ellipsis;
  /* line-clamp */
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-word;
  overflow-wrap: break-word;
`
